import i18n from "../../i18n";
import { fonts } from "./fonts";
import { fontsVi } from "./fontsVi";

const setFonts = (lng: string) => {
  [...fonts, ...fontsVi].forEach((font) => document.fonts.delete(font));
  const fontArray = lng.toLowerCase() === "vi" ? fontsVi : fonts;
  // The browser downloads only the faces needed by visible text.
  fontArray.forEach((font) => {
    font.display = "swap";
    document.fonts.add(font);
  });
};

setFonts(i18n.language);
i18n.on("languageChanged", setFonts);
